import React from 'react'
import './LoadingModules.scss'
import { ProgressSpinner } from 'primereact/progressspinner'
export default function ({ visible }) {
    return (
        visible ? (<div className="screen-loader1">
           <div>
           <ProgressSpinner />
           {/* <span>Loading Modules...</span> */}
           </div>
        </div>) : ""

    )
}
